(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    var buttons = document.querySelectorAll('.pdp-qcg-zertifikate--button');
    var textContents = document.querySelectorAll('.pdp-qcg-zertifikate--text-content');

    if (buttons.length === 0 || textContents.length === 0) {
      return;
    }

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        var buttonNumber = this.getAttribute('data-button');

        buttons.forEach(function (btn) {
          btn.classList.remove('active');
        });

        textContents.forEach(function (content) {
          content.classList.remove('active');
        });

        this.classList.add('active');

        var targetContent = document.querySelector(
          '.pdp-qcg-zertifikate--text-content[data-content="' + buttonNumber + '"]'
        );
        if (targetContent) {
          targetContent.classList.add('active');
        }
      });
    });
  });
})();
